import { Typography } from '../../../../../design-system/components/typography/Typography';
import { HeaderBlockSliceType } from '../../../../../domains/Prismic/BrandPages/BrandPagesDocument';

import style from './HeaderBlockSlice.module.css';

export type HeaderBlockSliceProps = HeaderBlockSliceType;

export function HeaderBlockSlice({ title, subtitle, version }: HeaderBlockSliceProps) {
    return (
        <div className={style.wrapper}>
            {subtitle ? (
                <Typography
                    as="div"
                    scale="primary-m-extra-bold"
                    className={version === 'green' ? style.subtitleYellow : undefined}
                >
                    {subtitle?.toUpperCase()}
                </Typography>
            ) : null}
            <Typography as="h1" scale="secondary-xxl-bold">
                {title}
            </Typography>
        </div>
    );
}
